// Resolvers
import { getPaymentFlowDataResolver } from '../resolvers/payment.resolver';
// Translations
import { FETCHING_DESCRIPTION, FETCHING_TITLE } from '../translations/payment.translations';

const PAYMENT_LAYOUT_COMPONENT_PROPS = {
  externalFetchingConfiguration: {
    description: FETCHING_DESCRIPTION,
    title: FETCHING_TITLE,
  },
  fetchResolver: getPaymentFlowDataResolver,
};

const PAYMENT_POLLING_TIMEOUT = {
  timeout: 10, // seconds
};

export { PAYMENT_LAYOUT_COMPONENT_PROPS, PAYMENT_POLLING_TIMEOUT };
